<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروها">
      <Loading v-if="loading"></Loading>
      <div v-if="!loading">
        <div v-if="!error">
          <div class="search-area">
            <div class="search-input-area">
              <h3 class="center text-white">{{ brand.title }}</h3>
            </div>
          </div>
          <br/>
          <ion-grid>
            <ion-row>
              <ion-col size="6" v-for="item in models" :key="item._id">
                <router-link :to="'/cars/model/'+item._id">
                  <div class="brand-model-item">
                    <div class="thumbnail">
                      <img :src="item.pic_url"/>
                    </div>
                    <div class="title">
                      <h4>{{ item.title }}</h4>
                    </div>
                  </div>
                </router-link>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage, IonGrid, IonRow, IonCol} from '@ionic/vue'
import {mapActions} from "vuex";
import Loading from "@/components/Loading";

export default {
  name: "models",
  data: function ()
  {
    return {
      loading: true,
      brand:null,
      error: null,
      brandId: null,
      searchInput: '',
      searchResults: [],
      models: []
    }
  },
  mounted()
  {
    this.brandId = this.$route.params.brandId;
    this.getBrandModels(this.brandId).then((result) =>
    {
      this.loading = false;
      if (result)
      {
        if (result.carModels)
        {
          this.brand = result.carBrand;
          this.models = result.carModels;
        }
        else
          this.error = result.error;
      }
      else
        this.error = 'لطفا از دسترسی تلفن همراه خود به اینترنت مطمئن شوید'
    })
  },
  methods: {
    ...mapActions("car", {
      getBrandModels: 'getBrandModels',
    })
  },
  components: {
    Loading,
    IonPage, IonGrid, IonRow, IonCol
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}
.thumbnail{
  text-align: center;
}
.thumbnail img {
  width: 125px;
  height: 125px;
  border-radius: 5px;
}
.title h4 {
  font-size: 16px;
  height: 45px;
}

</style>